import {
    login_request_invalid,
    login_request_send,
    login_request_valid
} from './../actions/postLogin'
import {
    registration_request_invalid,
    registration_request_send,
    registration_request_valid
} from './../actions/postRegistration'
import {
    reset_request_invalid,
    reset_request_send,
    reset_request_valid
} from './../actions/postReset'
import {
    reseted_request_invalid,
    reseted_request_send,
    reseted_request_valid
} from './../actions/postReseted'
import {
    logout_request_invalid,
    logout_request_send,
    logout_request_valid
} from './../actions/postLogout'
import {constInitialStateRequest, constInvalid, constSend, constValid} from "../../../constants";

const initialState = {
    user: window.user_data || null,
    logout: constInitialStateRequest(),
    login: constInitialStateRequest(),
    registration: constInitialStateRequest(),
    reset: constInitialStateRequest(),
    reseted: constInitialStateRequest(),
};

export const authReducer = function (state = initialState, action) {
    switch (action.type) {
        case login_request_invalid: {
            return {
                ...state,
                login: {
                    ...state.login,
                    ...constInvalid(),
                },
            };
        }
        case login_request_send: {
            return {
                ...state,
                login: {
                    ...state.login,
                    ...constSend(),
                },
            };
        }
        case login_request_valid: {
            let new_state = {
                ...state,
                login: {
                    ...state.login,
                    ...constValid(),
                },
            };
            if (action.data)
                new_state.user = {
                    ...action.data
                };
            return new_state;
        }
        case logout_request_invalid: {
            return {
                ...state,
                logout: {
                    ...state.logout,
                    ...constInvalid(),
                }
            };
        }
        case logout_request_send: {
            return {
                ...state,
                logout: {
                    ...state.logout,
                    ...constSend(),
                }
            };
        }
        case logout_request_valid: {
            return {
                ...state,
                logout: {
                    ...state.logout,
                    ...constValid(),
                },
                user: null,
            };
        }
        case registration_request_invalid: {
            return {
                ...state,
                registration: {
                    ...state.registration,
                    ...constInvalid(),
                },
            };
        }
        case registration_request_send: {
            return {
                ...state,
                registration: {
                    ...state.registration,
                    ...constSend(),
                },
            };
        }
        case registration_request_valid: {
            let new_state = {
                ...state,
                registration: {
                    ...state.registration,
                    ...constValid(),
                },
            };
            if (action.data)
                new_state.user = {
                    ...action.data
                };
            return new_state;
        }
        case reset_request_invalid: {
            return {
                ...state,
                reset: {
                    ...state.reset,
                    ...constInvalid(),
                },
            };
        }
        case reset_request_send: {
            return {
                ...state,
                reset: {
                    ...state.reset,
                    ...constSend(),
                },
            };
        }
        case reset_request_valid: {
            return {
                ...state,
                reset: {
                    ...state.reset,
                    ...constValid(),
                },
            };
        }
        case reseted_request_invalid: {
            return {
                ...state,
                reset: {
                    ...state.reset,
                    ...constInvalid(),
                },
            };
        }
        case reseted_request_send: {
            return {
                ...state,
                reset: {
                    ...state.reset,
                    ...constSend(),
                },
            };
        }
        case reseted_request_valid: {
            return {
                ...state,
                reset: {
                    ...state.reset,
                    ...constValid(),
                },
            };
        }
        default:
            return state;
    }
};